<app-navbar-style-admin></app-navbar-style-admin>

<div class="inner-banner inner-bg4">
    <div class="container">
        <div class="banner-list">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-7">
                    <ul class="list">
                        <li><a href="/adminPanel">Dashboard</a></li>
                        <li><i class='bx bx-chevron-right'></i></li>
                        <li class="active">CallBackResponse</li>
                    </ul>
                </div>
               
            </div>
        </div>
    </div>
</div>
<br>
<div class="container">
    <div class="row">
        <div class="col-lg-4 col-md-6 mb-4" *ngFor="let cb of callback">
            <div class="card">
                <div class="card-body" style="box-shadow: 0 0 10px 10px black;">
                    <h5 class="card-title">Name - {{ cb.yourName }}</h5>
                    <p class="card-text">Email-Id: {{ cb.email }}</p>
                    <p class="card-text">PH.NO: {{ cb.phoneNo }}</p>
                    <p class="card-text">Date : {{cb.dateTime}}</p>
                    <p class="card-text">Message : {{cb.yourMessage}}</p>
                </div>
            </div>
        </div>
    </div>
</div>

